import { GenericStatusInfoTitle, WaypointStatusName, DraftWaypointStatus } from '@caresend/types';

/**
 * Reverse map function for getWaypointStatusInfo
 * Maps GenericStatusInfoTitle to WaypointStatusName | DraftWaypointStatus
 *
 * I can’t believe I have to do this. @pumposh
 * TODO: Resovle the proper statuses for the denormalized data in the
 * cloud-side determination of the waypoint statuses.
 */
const getWaypointStatusFromInfoTitle = (statusInfoTitle) => {
    switch (statusInfoTitle) {
        case GenericStatusInfoTitle.PENDING_SCHEDULING:
            return DraftWaypointStatus.PENDING;
        case GenericStatusInfoTitle.SCHEDULED:
            return WaypointStatusName.CREATED;
        case GenericStatusInfoTitle.REJECTED:
            return DraftWaypointStatus.REJECTED;
        case GenericStatusInfoTitle.CANCELED:
            return DraftWaypointStatus.CANCELED;
        case GenericStatusInfoTitle.DRAFT:
            return WaypointStatusName.DRAFT;
        case GenericStatusInfoTitle.NURSE_ON_THE_WAY:
            return WaypointStatusName.TRANSIT_WAYPOINT;
        case GenericStatusInfoTitle.NURSE_AT_PATIENTS:
            return WaypointStatusName.AT_WAYPOINT;
        case GenericStatusInfoTitle.VISIT_COMPLETE:
            return WaypointStatusName.COMPLETE;
    }
};

export { getWaypointStatusFromInfoTitle };
